/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import LandingSection from "../../sections/Home/LandingSection/LandingSection";
import OurMissionSection from "../../sections/Home/OurMissionSection/OurMissionSection";
import CuratedCollection from "../../sections/Home/CuratedCollection/CuratedCollection";
import GoldenTiersSection from "../../sections/Home/GoldenTiersSection/GoldenTiersSection";
import SubscriptionSection from "../../sections/Home/SubscriptionSection/SubscriptionSection";
import useScrollToTop from "../../utils/useScrollToTop";

const HomePage = ({data}) => {


  useScrollToTop()

  return (
    <div>
      <LandingSection data={data}/>
      <OurMissionSection />
      <CuratedCollection />
      <GoldenTiersSection />
      <SubscriptionSection />
    </div>
  );
};

export default HomePage;
